import { render, staticRenderFns } from "./LifestyleQuestion.vue?vue&type=template&id=9486e17c&scoped=true&"
import script from "./LifestyleQuestion.vue?vue&type=script&lang=js&"
export * from "./LifestyleQuestion.vue?vue&type=script&lang=js&"
import style0 from "./LifestyleQuestion.vue?vue&type=style&index=0&id=9486e17c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9486e17c",
  null
  
)

export default component.exports